import { el } from 'redom';

import './index.scss';

class RecordingProgressDisplay {

  constructor() {

    this.percentage = el('span.recording-progress-display__percentage', 'Exporting 0%');

    this.el = el('.recording-progress-display', [
      this.percentage,
      el('ht-spinner', { size: 'small' })
    ]);

  }

  update(percentage) {

    this.percentage.textContent = `Exporting ${percentage}%`;

  }

}

export default RecordingProgressDisplay;